export default __webpack_public_path__ + "static/media/arrowLeftGray.c4a833ec.svg";